/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions } from './FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions';
import {
    instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions,
    FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsFromJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsFromJSONTyped,
    FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsToJSON,
} from './FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions';

/**
 * @type FxIdApplicationPublicDataBuilderPublicDataBaseSupport
 * 
 * @export
 */
export type FxIdApplicationPublicDataBuilderPublicDataBaseSupport = FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions;

export function FxIdApplicationPublicDataBuilderPublicDataBaseSupportFromJSON(json: any): FxIdApplicationPublicDataBuilderPublicDataBaseSupport {
    return FxIdApplicationPublicDataBuilderPublicDataBaseSupportFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseSupportFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPublicDataBaseSupport {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions(json)) {
        return FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseSupportToJSON(json: any): any {
    return FxIdApplicationPublicDataBuilderPublicDataBaseSupportToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseSupportToJSONTyped(value?: FxIdApplicationPublicDataBuilderPublicDataBaseSupport | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions(value)) {
        return FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsToJSON(value as FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions);
    }

    return {};
}

